import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HelpdeskDetails from './helpdeskDetail';
import {
  getHelpdeskDetail
} from 'services/redux/brandActivtion/conductCamp/action';

const mapStateToProps = (state) => ({
  HelpdeskDetails: state.ConductCampReducer.helpdeskDetail
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHelpdeskDetail
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskDetails);
